import React from 'react';
import ReactDOM from 'react-dom';
import MainApp from './MainApp';
import { initMixpanel, identifyUser } from 'lib/mixpanel';
import { auth } from 'api/credentials';
import { pushUserDataLayer } from 'util/dataLayer';

initMixpanel();

// Identificar usuário logado no Mixpanel
const token = localStorage.getItem( 'af-token' );
if ( token ) {
	const userName = auth.getJwtName( token );
	const userEmail = auth.getJwtLogin( token );
	const userId = auth.getUserId( token );

	if ( userId && ( userName || userEmail ) ) {
		identifyUser( userId, {
			name  : userName,
			email : userEmail
		} );
	}

	pushUserDataLayer();
}

const rootEl = document.getElementById( 'app-site' );

window.process = {
	env: {
		NODE_ENV: 'development'
	}
};



// Create a reusable render method that we can call more than once
let render = () => {
	// Dynamically import our main App component, and render it
	ReactDOM.render(
		<MainApp/>,
		rootEl
	);
};

if ( module.hot ) {
	module.hot.accept( './MainApp', () => {
		render(
			<MainApp/>,
			rootEl
		);
	} );
}

render();
